import { useState, useEffect } from 'react';
import { PlusCircle, Trash2, ArrowUp, ArrowDown } from 'lucide-react';
import TimePicker from '../components/TimePicker';
import MobileNavbar from "../components/MobileNavbar";

export default function Admin() {
  const [data, setData] = useState(null);
  const [story, setStory] = useState('');
  const [hours, setHours] = useState({
    monday: '',
    tuesday: '',
    wednesday: '',
    thursday: '',
    friday: '',
    saturday: '',
    sunday: '',
    saturday_breakfast: '',
    sunday_breakfast: '',
  });
  const [menu, setMenu] = useState([]);
  const [loggedIn, setLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [selectedCategoryTitle, setSelectedCategoryTitle] = useState('');

  useEffect(() => {
    if (loggedIn) {
      fetch('http://localhost:3001/api/data')
        .then((res) => res.json())
        .then((data) => {
          setData(data);
          setStory(data.story);
          setHours(data.hours);
          setMenu(data.menu);
          if (data.menu && data.menu.length > 0) {
            setSelectedCategoryTitle(data.menu[0].title);
          }
        });
    }
  }, [loggedIn]);

  const handleLogin = () => {
    if (username === 'admin' && password === 'admin') {
      setLoggedIn(true);
    } else {
      alert('Invalid credentials');
    }
  };

  const handleSave = () => {
    const newData = {
      ...data,
      story,
      hours,
      menu,
    };
    fetch('http://localhost:3001/api/data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newData, null, 2),
    })
    .then(res => res.json())
    .then(() => alert("Changes saved successfully!"))
    .catch(() => alert("Error saving changes."));
  };

  const handleMenuChange = (sectionTitle, itemIndex, field, value) => {
    const newMenu = menu.map(section => {
      if (section.title === sectionTitle) {
        const newItems = [...section.items];
        newItems[itemIndex] = { ...newItems[itemIndex], [field]: value };
        return { ...section, items: newItems };
      }
      return section;
    });
    setMenu(newMenu);
  };

  const handleAddItem = (sectionTitle) => {
    const newMenu = menu.map(section => {
      if (section.title === sectionTitle) {
        const newItems = [...section.items, { name: 'New Item', price: 0, description: '' }];
        return { ...section, items: newItems };
      }
      return section;
    });
    setMenu(newMenu);
  };

  const handleDeleteItem = (sectionTitle, itemIndex) => {
    const newMenu = menu.map(section => {
      if (section.title === sectionTitle) {
        const newItems = [...section.items];
        newItems.splice(itemIndex, 1);
        return { ...section, items: newItems };
      }
      return section;
    });
    setMenu(newMenu);
  };

  const moveItem = (sectionTitle, itemIndex, direction) => {
    const newMenu = [...menu];
    const section = newMenu.find(s => s.title === sectionTitle);
    const newIndex = itemIndex + direction;

    if (newIndex >= 0 && newIndex < section.items.length) {
      const [movedItem] = section.items.splice(itemIndex, 1);
      section.items.splice(newIndex, 0, movedItem);
      setMenu(newMenu);
    }
  };

  const moveCategory = (index, direction) => {
    const newMenu = [...menu];
    const newIndex = index + direction;

    if (newIndex >= 0 && newIndex < newMenu.length) {
      const [movedItem] = newMenu.splice(index, 1);
      newMenu.splice(newIndex, 0, movedItem);
      setMenu(newMenu);
    }
  };

  if (!loggedIn) {
    return (
      <section className="py-12 px-6 max-w-md mx-auto">
        <h2 className="text-3xl font-bold text-sapphire mb-6 text-center">Admin Login</h2>
        <div className="bg-blush/20 p-6 rounded-xl shadow space-y-4">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full p-3 rounded border"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 rounded border"
          />
          <button
            onClick={handleLogin}
            className="w-full bg-orange text-white py-3 rounded-xl font-semibold hover:bg-sapphire"
          >
            Login
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 px-6 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold text-sapphire mb-6">Admin Panel</h2>
      <div className="space-y-4">
        <div>
          <label className="block font-bold mb-1">Our Story</label>
          <textarea
            value={story}
            onChange={(e) => setStory(e.target.value)}
            className="w-full p-3 rounded border"
            rows="4"
          ></textarea>
        </div>
        <div>
          <h3 className="text-2xl font-bold text-sapphire mt-8 mb-4">Hours</h3>
          {Object.keys(hours).map(day => (
            <div key={day} className="grid grid-cols-2 gap-4 items-center mb-2">
              <label className="capitalize">{day.replace('_', ' ')}</label>
              <TimePicker
                value={hours[day]}
                onChange={(value) => setHours({ ...hours, [day]: value })}
              />
            </div>
          ))}
        </div>

        <div>
          <h3 className="text-2xl font-bold text-sapphire mt-8 mb-4">Menu</h3>
          {data && (
            <>
              <div className="flex items-center gap-2 mb-4">
                <select
                  className="w-full p-3 rounded border"
                  value={selectedCategoryTitle}
                  onChange={(e) => setSelectedCategoryTitle(e.target.value)}
                >
                  {menu.map((section) => (
                    <option key={section.title} value={section.title}>
                      {section.title}
                    </option>
                  ))}
                </select>
                <button onClick={() => moveCategory(menu.findIndex(s => s.title === selectedCategoryTitle), -1)} className="text-gray-500 hover:text-gray-700">
                  <ArrowUp size={20} />
                </button>
                <button onClick={() => moveCategory(menu.findIndex(s => s.title === selectedCategoryTitle), 1)} className="text-gray-500 hover:text-gray-700">
                  <ArrowDown size={20} />
                </button>
              </div>
              {menu.filter(s => s.title === selectedCategoryTitle).map((section) => (
                <div key={section.title}>
                  <div className="flex items-center gap-2 mb-2">
                    <h4 className="text-xl font-bold">{section.title}</h4>
                    <button onClick={() => handleAddItem(section.title)} className="text-green-500 hover:text-green-700">
                      <PlusCircle size={20} />
                    </button>
                  </div>
                  {section.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="grid grid-cols-6 gap-2 mb-2 items-center">
                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => handleMenuChange(section.title, itemIndex, 'name', e.target.value)}
                        className="w-full p-2 rounded border col-span-2"
                        placeholder="Name"
                      />
                      <input
                        type="number"
                        value={item.price}
                        onChange={(e) => handleMenuChange(section.title, itemIndex, 'price', e.target.value)}
                        className="w-full p-2 rounded border"
                        placeholder="Price"
                      />
                      <input
                        type="text"
                        value={item.description}
                        onChange={(e) => handleMenuChange(section.title, itemIndex, 'description', e.target.value)}
                        className="w-full p-2 rounded border"
                        placeholder="Description"
                      />
                      <button onClick={() => handleDeleteItem(section.title, itemIndex)} className="text-red-500 hover:text-red-700">
                        <Trash2 size={20} />
                      </button>
                      <div className="flex">
                        <button onClick={() => moveItem(section.title, itemIndex, -1)} className="text-gray-500 hover:text-gray-700">
                          <ArrowUp size={20} />
                        </button>
                        <button onClick={() => moveItem(section.title, itemIndex, 1)} className="text-gray-500 hover:text-gray-700">
                          <ArrowDown size={20} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </>
          )}
        </div>

        <button
          onClick={handleSave}
          className="w-full bg-orange text-white py-3 rounded-xl font-semibold hover:bg-sapphire"
        >
          Save Changes
        </button>
      </div>
    </section>
  );
}
